module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"completion_date":"Completion Date","due_date":"Due Date","remind_date":"Reminder date"},"fr":{"completion_date":"Date de complétion","due_date":"Date d\u0027échéance","remind_date":"Date de rappel"},"de":{"completion_date":"Fertigstellungstermin","due_date":"Geburtstermin","remind_date":"Erinnerungsdatum"}}')
  delete Component.options._Ctor
}
